<template>
  <div class="wlx-tea-apply-lec-wrapper">
    <div class="tea-uploead-doc-con">
      <p class="p-doc-title">上传申请文档</p>
      <applyFileUpload :url="urlAliyunOSS" :files="files" @done="onAllFilesUpload"></applyFileUpload>
      <div class="apply-btn-con">
        <el-button size="small" type="primary" @click="submitApply" :disabled="isDisabled">提交申请</el-button>
      </div>
    </div>
    <div class="download-reven-file-con clearfix">
      <div class="fl reven-file-con">
        <h3 class="h3-wl-title">
          <span class="sp-border-class"></span>
          <span class="sp-title-text">查看讲师协议</span>
        </h3>
        <div class="exam-text-content">
          <div class="file-class-text clearfix">
            <p class="fl file-name-con">北京中物联物流采购培训中心关于培训讲师的合作协议2019版.doc</p>
            <a
              href="http://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/y8FdfX3Xa5XJBmk6.xls?response-content-disposition=attachment;filename=北京中物联物流采购培训中心培训讲师申请表.doc"
              class="a-download-text fr" 
            >点击下载</a>
          </div>
        </div>
      </div>
      <div class="fl reven-file-con reven-file-con-apply">
        <h3 class="h3-wl-title">
          <span class="sp-border-class"></span>
          <span class="sp-title-text">培训讲师申请表</span>
        </h3>
        <div class="exam-text-content">
          <div class="file-class-text clearfix">
            <p class="fl file-name-con">北京中物联物流采购培训中心培训讲师申请表.doc</p>
            <a
              href="http://file.clpp.org.cn/66ykt/ori/62aoalgo67ralzns3hnyea/y8FdfX3Xa5XJBmk6.xls?response-content-disposition=attachment;filename=北京中物联物流采购培训中心培训讲师申请表.doc"
              class="a-download-text fr"
            >点击下载</a>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="DateCreated" label="日期" width="180"></el-table-column>
        <el-table-column prop="AssociationName" label="协会名称" width="180"></el-table-column>
        <el-table-column prop="DocTitle" label="上传文件名"></el-table-column>
        <el-table-column prop="isAuthentication" label="是否通过">
          <template slot-scope="scope">
            <span style="color: #2D82FF" v-if="scope.row.isAuthentication == '待审核'">待审核</span>
            <span style="color: #E53939" v-if="scope.row.isAuthentication == '审核未通过'">审核未通过</span>
            <span style="color: #05C94F" v-if="scope.row.isAuthentication == '审核通过'">审核通过</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini">
              <a
                class="el-icon-download xiazai"
                :href="'/api/design/CourseWare/downloadfile?fileKey='+scope.row.downloadUrl+'&filename='+scope.row.DocTitle"
              >下载</a>
            </el-button>
            <el-button
              size="mini"
              v-if="scope.row.isAuthentication == '审核未通过'"
              type="danger"
              @click="ReasonRejection(scope.row.ReasonRejection)"
            >原因</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="提示"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="30%"
    >
      <span>{{ReasonRejectionText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="完善信息"
      :visible.sync="dialogVisibleBaseInfo"
      :append-to-body="true"
    >
      <div>
        <el-form ref="form" :model="form" label-width="100px" class="tea-info-form">
          <el-form-item label="姓名：">
            <el-input v-model="form.Name"></el-input>
          </el-form-item>
          <el-form-item label="头像：">
            <imageUpload :url="urlAliyunOSS" :files.sync="form.CoverUrl" format="image"></imageUpload>
          </el-form-item>
          <!-- <el-form-item label="性别：">
            <el-radio-group v-model="form.Gender">
              <el-radio label="0">男</el-radio>
              <el-radio label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>-->
          <el-form-item label="工号：">
            <el-input v-model="form.Number"></el-input>
          </el-form-item>
          <el-form-item label="所在学校:">
            <el-select v-model="form.SchoolId" clearable placeholder="请选择">
              <el-option
                v-for="item in schoolList"
                :key="item.Id"
                :label="item.SchoolName"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号：">
            <el-input v-model="form.IDNumber"></el-input>
          </el-form-item>
          <!-- <el-form-item label="手机号：">
            <el-input v-model="form.Mobile"></el-input>
          </el-form-item>-->
          <!-- <el-form-item label="简介：">
            <el-input type="textarea" :rows="4" v-model="form.Desc"></el-input>
          </el-form-item>-->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBaseInfo = false">取 消</el-button>
        <el-button type="primary" @click="updateBasicInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import applyFileUpload from "components/applyFileUpload.vue";
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      fileIds: [],
      files: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      isDisabled: false,
      tableData: [],
      dialogVisible: false,
      ReasonRejectionText: "",
      dialogVisibleBaseInfo: false,
      /********************** */
      form: {
        UserId: "",
        Name: "",
        CoverUrl: "",
        // Gender: "",
        IDNumber: "",
        Number: "",
        // Mobile: "",
        // Desc: "",
        SchoolId: ""
      },
      urlAliyunOSS: "/api/design/osssign/getsign",
      schoolList: []
    };
  },
  components: {
    applyFileUpload,
    imageUpload
  },
  created() {
    this.getApplyList();
    this.getSchoolList();
  },
  methods: {
    getBasicInfo() {
      let self = this;
      this.$http.get("/api/XOrg/teaBasicInfo/getBasicInfo").then(function(res) {
        if (res.code == 1) {
          self.form.UserId = res.userInfo.id;
          self.form.Name = res.userInfo.name;
          self.form.CoverUrl = res.userInfo.cover;
          // self.form.Gender = res.userInfo.gender;
          self.form.IDNumber = res.userInfo.iDNumber;
          self.form.SchoolId = res.userInfo.schoolId;
          self.form.Number = res.userInfo.number;
          // self.form.Mobile = res.userInfo.mobile;
          // self.form.Desc = res.userInfo.description;
        }
      });
    },
    testid(card) {
      var str,
        result = 0;
      card = card.toUpperCase();
      if (card.length === 18) {
        var map1 = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
          map2 = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];

        str = new String(card);
        for (var i = 0, len = str.length; i < len - 1; i++) {
          result += str[i] * map1[i];
        }
        if (map2[result % 11] != str[len - 1]) {
          return "请填写正确的身份证号码！";
        } else {
          return "1";
        }
      } else {
        return "请填写正确的身份证号码！";
      }
    },
    updateBasicInfo() {
      let self = this;
      var code = self.testid(this.form.IDNumber);
      if (code != 1) {
        this.$message({
          showClose: true,
          message: code,
          type: "warning"
        });
        return false;
      }
      this.$http
        .post("/api/XOrg/teaBasicInfo/perfectBasicInfo", {
          userId: this.form.UserId,
          name: this.form.Name,
          coverUrl: this.form.CoverUrl,
          // gender: this.form.Gender,
          iDNumber: this.form.IDNumber,
          schoolId: this.form.SchoolId,
          number: this.form.IDNumber
          // mobile: this.form.Mobile,
          // desc: this.form.Desc
        })
        .then(function(res) {
          if (res.code == 1) {
            self.$message.success(res.msg);
            self.dialogVisibleBaseInfo = false;
          }
        });
    },
    getSchoolList() {
      let self = this;
      this.$http
        .get("/api/XOrg/StudentManager/getSchoolList")
        .then(function(res) {
          if (res.code == 1) {
            self.schoolList = res.schoolList;
          }
        });
    },
    getApplyList() {
      let self = this;
      this.$http
        .get("/api/XOrg/teaCertificate/getApplyList")
        .then(function(res) {
          if (res.code == 1) {
            self.tableData = res.list;
            var index = res.list.find(i => i.isAuthentication == "审核通过");
            if (index) {
              self.isDisabled = true;
            }
          }
        });
    },
    ReasonRejection(text) {
      this.dialogVisible = true;
      this.ReasonRejectionText = text;
    },
    onAllFilesUpload(files) {
      this.fileIds = [];
      this.fileIds = files;
    },
    submitApply() {
      let self = this;
      if (this.fileIds.length == 0) {
        this.$message.warning("请提交申请材料！");
        return;
      }
      this.$http
        .post("/api/XOrg/teaCertificate/submitApplyMaterial", {
          materialIds: this.fileIds
        })
        .then(function(res) {
          if (res.code == 1) {
            self.$message.success(res.msg);
            self.isDisabled = true;
            self.getApplyList();
          } else if (res.code == -2) {
            self.dialogVisibleBaseInfo = true;
            self.getBasicInfo();
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-tea-apply-lec-wrapper {
  margin: 20px 0 0 30px;
  background: #fff;
  padding: 40px 0 40px 90px;
  .tea-uploead-doc-con {
    width: 629px;
    .p-doc-title {
      margin: 20px 0 23px 0;
      font-size: 16px;
      text-align: center;
    }
    .el-upload-dragger {
      width: 629px;
      height: 328px;
      .el-icon-upload {
        margin-top: 130px;
        font-size: 80px;
      }
    }
    .apply-btn-con {
      margin-top: 20px;
      padding: 20px 0;
      text-align: center;
    }
  }
  .tip-wrapper {
    margin-top: 120px;
    margin-left: 20px;
    a {
      text-decoration: underline;
    }
  }
  .download-reven-file-con{
    margin-bottom: 50px;
    .reven-file-con{
      width: 40%;
    }
    .reven-file-con-apply{
      margin-left: 40px;
    }
    .exam-text-content{
      margin-top: 17px;
    }
    .file-name-con{
      width: calc(100% - 110px);
      font-size: 14px;
      color: #333333;
    }
    .h3-wl-title{
      padding-left: 10px;
      font-size: 16px;
      border-left:3px solid #2D82FF;
      line-height: 1;
      color: #333333;
    }
    .a-download-text{
      text-decoration: underline;
    }
  }
}
</style>
